import React from 'react';
import {observer} from 'mobx-react';

const branches = [
    {label: 'Military Frames Shop', url: '/shop'},
    {label: 'Air Force Frame Designer', url: '/air-force-frame-designer'},
    {label: 'Air National Guard Frame Designer', url: '/air-national-guard-frame-designer'},
    {label: 'Army Frame Designer', url: '/army-frame-designer'},
    {label: 'Army National Guard Frame Designer', url: '/army-national-guard-frame-designer'},
    {label: 'Coast Guard Frame Designer', url: '/coast-guard-frame-designer'},
    {label: 'Marines Frame Designer', url: '/marines-frame-designer'},
    {label: 'Navy Frame Designer', url: '/navy-frame-designer'},
    {label: 'Space Force Frame Designer', url: '/space-force-frame-designer'},
];

@observer
export default class CAFMF extends React.Component {
    onBranchChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const url = e.target.value;
        if (url) {
            window.location.href = url;
        }
    };

    render() {
        return (
            <div
                className="gray-box caf-doc mt-2"
                style={{marginBottom: '0.5rem'}}
            >
                <div
                    className="row"
                    style={{display: 'flex', justifyContent: 'space-between'}}
                >
                    <div className="col-12 col-sm-6">
                        <label
                            htmlFor="caf-branch-select"
                            style={{fontWeight: 700, marginBottom: '0.5rem', display: 'block'}}
                        >
                            Select a Military Force
                        </label>
                        <select
                            id="caf-branch-select"
                            className="form-select"
                            defaultValue=""
                            onChange={this.onBranchChange}
                        >
                            <option
                                value=""
                                disabled
                            >
                                -- Select a Force --
                            </option>
                            {branches.map(b => (
                                <option
                                    key={b.url}
                                    value={b.url}
                                >
                                    {b.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        );
    }
}
